import { useMemo } from "react";
import { useEntities } from "@hooks/useEntities";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import {
    NAVIGATION_SHORTCUTS,
    NavigationGate,
    NavigationShortcutDefinition,
    shortcutToKeys,
} from "./navigationShortcuts";

export type ResolvedNavigationShortcut = NavigationShortcutDefinition & {
    keys: string | undefined;
    isEnabled: boolean;
};

export function useResolvedNavigationShortcuts(): ResolvedNavigationShortcut[] {
    const businessEntities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });
    const hasBusinessEntities = businessEntities.length > 0;
    const { enabled: isGlFirst } = useIsGlFirst();

    return useMemo(() => {
        const gateValues: Record<NavigationGate, boolean> = {
            hasBusinessEntities,
            notGlFirst: !isGlFirst,
        };

        return NAVIGATION_SHORTCUTS.map((shortcut) => ({
            ...shortcut,
            keys: shortcutToKeys(shortcut.shortcut),
            isEnabled: [shortcut.gate ?? []]
                .flat()
                .every((gate) => gateValues[gate]),
        }));
    }, [hasBusinessEntities, isGlFirst]);
}
